import { ThemeOptions, createTheme } from '@mui/material';

const baseThemeOptions: ThemeOptions = {
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        sx: {
          borderRadius: '1.5rem',
        },
      },
    },
  },
};

export const theme = {
  lightTheme: createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#1165ec',
      },
      secondary: {
        main: '#fc7482',
      },
      background: {
        default: '#f3f3f3',
      },
    },
    ...baseThemeOptions,
  }),
  darkTheme: createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#1165ec',
      },
      secondary: {
        main: '#b483de',
      },
      background: {
        default: '#645090',
        paper: '#12234a',
      },
    },
    ...baseThemeOptions,
  }),
};
